import React,  { PureComponent }  from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './mdt-anchor.css';

export class MDTAnchor extends PureComponent {
    constructor(props) {
        super(props);

    }
    static propTypes = {
        name: PropTypes.string,
        onClick: PropTypes.func,
        href: PropTypes.string,
        target: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.string,
        download: PropTypes.bool,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        dataTest: PropTypes.string
      }
    static defaultProps = {
        onClick(){},
        download:false,
        disabled: false,
        dataTest: 'mdtAnchor'
    }

    renderAnchor = () => {
        const {
          disabled,
          className,
          href,
          title,
          target,
          name,
          type,
          onClick,
          download,
          dataTest
        } = this.props;
        const anchorClassName = classNames(className,'mdt-anchor');

        if (!disabled) {
          return (
            <a href={href}
              className={anchorClassName}
              title={title}
              target={target}
              name={name}
              type={type}
              onClick={onClick}
              download={download}
              data-test={dataTest}
            >
                {this.props.children}
            </a>
          )
        } else {
          return (
          <span className={`disabled ${anchorClassName}`} data-test={dataTest}> {this.props.children} </span>
          )
        }
    };

    render() {
        return this.renderAnchor();
    }
}


export default MDTAnchor;